import React from 'react';
import { connect } from 'react-redux';
import makeRequest from 'utils/makeRequest';
import PropTypes from 'prop-types';
import LiveblogStickyElection from 'components_v2/common/LiveblogStickyElection/LiveblogStickyElectionLoader';
import Link from 'components/Link';
import s from './ExitPollRHSWrapper.scss';

function fetchData(feedUrl, callback, isMobile) {
  makeRequest
    .get(feedUrl, { isMobile }, 'skipfeedengine')
    .catch(err => console.log(err))
    .then(data => {
      if (
        data &&
        data.status === 200 &&
        data.data &&
        typeof callback === 'function'
      ) {
        callback(data.data);
      }
    });
}

class RHSWidgetWithExitPoll extends React.Component {
  constructor(props) {
    super();
    this.data = props.item;
    this.state = {
      ExitPollData: null,
    };
  }

  componentDidMount() {
    const { dataUrl = '' } = this.data;
    const { isIframeCssRequired, isMobile } = this.props;
    if (dataUrl) {
      const url = __PROD__
        ? dataUrl
        : dataUrl.replace('timesofindia', 'toidev');
      fetchData(url, this.setExitPollData, isMobile);
    }
    if (isIframeCssRequired === true) {
      import('../../../scss_v2/base/_base.scss').then();
      import('../../../components_v2/desktop/Layout/Layout.scss').then();
    }
  }

  getSortedStates = data => {
    if (
      data &&
      data.states instanceof Array &&
      this.props.preActiveState &&
      typeof this.props.preActiveState === 'string'
    ) {
      const pinState = data.states.find(
        st => st.sname === this.props.preActiveState,
      );
      const otherState = data.states.filter(
        st => st.sname !== this.props.preActiveState,
      );
      data.states =
        typeof pinState !== 'undefined' && otherState.length > 0
          ? [pinState, ...otherState]
          : data.states;
    }
  };

  setExitPollData = data => {
    // this.getSortedStates(data);
    this.setState({ ExitPollData: data });
  };

  isExitPoll = () => {
    const { isIframeExitPoll = undefined } = this.props;
    if (typeof isIframeExitPoll !== 'undefined') {
      return isIframeExitPoll;
    }
    return !!(
      this.state.ExitPollData && this.state.ExitPollData.exitpoll === '1'
    );
  };

  getSelectedState = data => {
    let selectedState;
    if (
      data &&
      data.states &&
      Array.isArray(data.states) &&
      data.states.length
    ) {
      for (let i = 0; i < data.states.length; i += 1) {
        const stateData = data.states[i];
        if (stateData && stateData.selected === '1') {
          selectedState = stateData && stateData.sname;
          break;
        }
      }
      return selectedState;
    }
    return undefined;
  };

  render() {
    const {
      hideLiveblog,
      hideStarCandidate,
      isIframeCssRequired,
      isIframeExitPoll,
      electionFlag,
      bgColor,
      bgColorOuter,
    } = this.props;
    if (this.isExitPoll()) return null;
    const backGroundStyle = bgColor ? `#${bgColor}` : '';
    const backGroundStyleOuter = bgColorOuter ? `#${bgColorOuter}` : '';
    return electionFlag &&
      this.state.ExitPollData &&
      this.state.ExitPollData.states &&
      !this.state.ExitPollData.error ? (
      <div
        style={{ backgroundColor: backGroundStyleOuter }}
        className={`${s.exitpolrhs} ${
          this.state.ExitPollData.exitpoll === '1' ? 'exitPollRHS' : 'resultRHS'
        } ${this.state.ExitPollData.starcnd === '1' ? 'lbStarCndtRHS' : ''}`}
      >
        {isIframeCssRequired && (
          <div className={s.ETheader}>
            <span className={s.ETheading}>
              {(this.state &&
                this.state.ExitPollData &&
                this.state.ExitPollData.displaytext) ||
                `Assembly Elections 2023`}
            </span>
            <span className={s.logo}>
              <img src="https://static.toiimg.com/photo/82253493.cms" alt="" />
            </span>
          </div>
        )}
        {!isIframeCssRequired && (
          <Link
            to="https://timesofindia.indiatimes.com/elections/assembly-elections"
            target="_blank"
            title={this.state.ExitPollData.heading}
            className={`${s.rhsheading}`}
            data-ga={`${
              typeof window === 'object' &&
              window.location.pathname.toLowerCase().match('/articleshow/')
                ? `Election_${
                    this.state.ExitPollData.exitpoll === '1' ? 'Exit' : 'Result'
                  }_AS_Widget|Click`
                : `Election_${
                    this.state.ExitPollData.exitpoll === '1' ? 'Exit' : 'Result'
                  }_Live_Blog_Widget|Click`
            }`}
            data-setgacategory
          >
            <h4>{this.state.ExitPollData.heading}</h4>
          </Link>
        )}
        {this.state.ExitPollData.exitpoll !== '1' &&
          this.state.ExitPollData.starcnd !== '1' && (
            <p
              className={`${isIframeCssRequired ? s.iframe_Cvoter : ''} ${
                isIframeExitPoll ? s.hide : ''
              }`}
            >
              Source: Pvalue
            </p>
          )}
        <div
          style={{ backgroundColor: backGroundStyle }}
          className={`${s.exitpolrhsIn} ${isIframeCssRequired ? s.iframe : ''}`}
        >
          <LiveblogStickyElection
            data={this.state.ExitPollData}
            isWapView={false}
            isExitPoll={this.isExitPoll()}
            cssObject={{
              statewrapper: s.statewrapper,
              sources: s.source,
              totalseatcount: s.totalseatcount,
              tabList: s.tabList,
              contentwrapper: s.contentwrapper,
            }}
            hideBattle={!this.isExitPoll()}
            isRHSWidget
            hideLiveblog={hideLiveblog}
            backGroundStyle={backGroundStyle}
            hideStarCandidate={hideStarCandidate}
            electionDefaultState={
              isIframeCssRequired
                ? this.props.preActiveState
                : this.getSelectedState(this.state.ExitPollData)
            }
          />
        </div>
      </div>
    ) : null;
  }
}

RHSWidgetWithExitPoll.propTypes = {
  isIframeCssRequired: PropTypes.bool,
  hideStarCandidate: PropTypes.bool,
  preActiveState: PropTypes.string,
  electionFlag: PropTypes.bool,
  bgColor: PropTypes.string,
  bgColorOuter: PropTypes.string,
  isMobile: PropTypes.bool,
};

RHSWidgetWithExitPoll.defaultProps = {
  isIframeCssRequired: false,
  hideStarCandidate: false,
  preActiveState: null,
  electionFlag: true,
  bgColor: '',
  bgColorOuter: '',
  isMobile: false,
};

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});
export default connect(mapStateToProps)(RHSWidgetWithExitPoll);
